const APP_SHELL_PREFIXES = [
  "/user-dashboard",
  "/subscriber",
  "/bank-feeds-connected",
  "/add-member-to-subscriber",
  "/create-new-exacc-file",
  "/create-new-subscriber",
  "/create-demo-file",
  "/my-details",
  "/logout",
  "/dev/",
];

function isLocalhostDashboardRoot() {
  return (
    process.env.REACT_APP_USE_SAMPLE_DATA === "true" ||
    (typeof window !== "undefined" && window.location.hostname === "localhost")
  );
}

/** Routes that use MainNavigation / dashboard shell and should show the global footer. */
export function isAppShellRoute(pathname) {
  if (pathname === "/") {
    return isLocalhostDashboardRoot();
  }
  return APP_SHELL_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/** Auth / login layout routes — footer hidden to avoid 100vh + footer scroll. */
export function isAuthShellRoute(pathname) {
  return !isAppShellRoute(pathname);
}
